import React, {FC, lazy, ReactElement, Suspense, useEffect} from "react";
import NavBar from "./components/NavBar";
import {Route, Routes} from "react-router-dom";
import Loading from "./components/Loading";
import {Grid} from "@mui/material";

import "./MainApp.scss";
import SnackbarToast from "./components/errors/SnackbarToast";
import {LoginInfo} from "./contexts/Configuration";
import {saveUserInfo} from './reducers/accessReducer';
import {getBalance} from "./reducers/billingReducer";
import {useAppDispatch} from "./hooks/storeHooks";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import useExecWithToken from "./utils/FetchUtils";
import {InteractionStatus} from "@azure/msal-browser";
import {jwtDecode} from "jwt-decode";
import {IdTokenPayload} from "./utils/IdTokenPayload";

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) => (
    <Suspense fallback={<Loading/>}>
        <Component {...props}/>
    </Suspense>
)

const Billing = Loadable(lazy(() => import ("./pages/Billing")));
const Transcription = Loadable(lazy(() => import ("./pages/Transcription")));
const BackOffice = Loadable(lazy(() => import ("./pages/BackOffice")));


const OperatorApp: FC<OperatorAppProps> = ({}): ReactElement => {

    const dispatch = useAppDispatch();
    const {instance, accounts, inProgress} = useMsal();
    let isAuthenticated = useIsAuthenticated();

    const execWithToken = useExecWithToken();

    useEffect(() => {
        if (!isAuthenticated || !(inProgress === InteractionStatus.None && accounts.length > 0))
            return;

        execWithToken((token) => {
            let activeAccount = accounts[0];
            const decode = jwtDecode<IdTokenPayload>(token.replace("Bearer ", ""));
            const roles= decode.roles;
            const loginInfo: LoginInfo = {account: activeAccount, token: token, roles: roles};

            // dispatch(retrieveUserInfo(loginInfo));
            dispatch(saveUserInfo(loginInfo));
            dispatch(getBalance({token: token}))
        });

    }, [isAuthenticated, accounts]);

    return (
        <Grid container spacing={0} className='main-container'>
            {/*NavBar*/}
            <Grid item xs={1} md={2} className='nav-bar-component'>
                <NavBar/>
            </Grid>
            {/*Body*/}
            <Grid item xs={11} md={10} className='content-container'>
                <div className='route-container'>
                    <Routes>
                        <Route path='/' element={<SnackbarToast><Transcription/></SnackbarToast>}/>
                        <Route path='/billing' element={<SnackbarToast><Billing/></SnackbarToast>}/>
                        <Route path='/backoffice' element={<SnackbarToast><BackOffice/></SnackbarToast>}/>
                    </Routes>
                </div>
            </Grid>
        </Grid>
    )
}


type OperatorAppProps = {}

export default OperatorApp;
